import { toast } from 'react-toastify';
import { isDev } from '../components/utils/env';
import * as _ from 'lodash';
import { logout } from './current-user/CurrentUserActions';
const statusCodes = [500];

export default store => next => action => {
  if (action.payload) {
    const state = store.getState();
    const payload = { ...action.payload };
    if (payload.status === 401 && state.currentUser.data !== null) { // we may get 401 for multiple request, let's logout only once
      store.dispatch(logout('Your session has expired. Please login again.'));
    } else if (statusCodes.includes(payload.status)) {
      const message = _.get(payload, 'response.error.message', '');
      const generalMessage = _.get(payload, 'message', '');
      setTimeout(() => toast.error(`Something went wrong. Please try again later. ${generalMessage} ${isDev ? message : ''}`), 0); // TODO: move this to redux action
      if (isDev) {
        console.error(message);
      }
      return next(action);
    } else {
      return next(action);
    }
  } else {
    return next(action);
  }
}



// WEBPACK FOOTER //
// ./src/store/api-error.js